'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_AppDocumentStorageFormat() {
}
export { $c_Lapp_data_AppDocumentStorageFormat as $c_Lapp_data_AppDocumentStorageFormat };
$p = $c_Lapp_data_AppDocumentStorageFormat.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_AppDocumentStorageFormat;
/** @constructor */
function $h_Lapp_data_AppDocumentStorageFormat() {
}
export { $h_Lapp_data_AppDocumentStorageFormat as $h_Lapp_data_AppDocumentStorageFormat };
$h_Lapp_data_AppDocumentStorageFormat.prototype = $p;
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
//# sourceMappingURL=app.data.-App-Document-Storage-Format.js.map
